import { combineReducers } from 'redux'
import user from './user'
import theme from './theme'

export default combineReducers({ user, theme })
